export default class FilterModel {
  constructor() {
      this.search = '';
      this.page = 1;
      this.pageSize = 10;
      this.sortCol = '';
      this.sortDir = '';
      this.category = null;

      this.action = '';
      this.userId = null;
      this.actionType = null;
      this.startDate = null;
      this.endDate = null;
      this.publish = true;

      this.make = null;
      this.model = null;
      this.position = null;
      this.productionYear = null;

  }

    asQuery() {
        let filter = {};
        if (this.search && this.search.length > 0) {
            filter.search = this.search;
        }
        if (this.page && this.page > 0) {
            filter.page = this.page;
        }
        if (this.pageSize && this.pageSize > 0) {
            filter.size = this.pageSize;
        }
        if (this.sortCol && this.sortCol.length > 0) {
            filter.sortCol = this.sortCol;
        }
        if (this.sortDir && this.sortDir.length > 0) {
            filter.sortDir = this.sortDir;
        }
        if (this.category && this.category > 0) {
            filter.category = this.category;
        }
        if (this.userId) {
            filter.userId = this.userId;
        }
        if (this.actionType) {
            filter.actionType = this.actionType;
        }
        if (this.startDate) {
            filter.startDate = this.startDate;
        }
        if (this.endDate) {
            filter.endDate = this.endDate;
        }
        if (this.make) {
            filter.make = this.make;
        }
        if (this.model) {
            filter.model = this.model;
        }
        if (this.position) {
            filter.position = this.position;
        }
        if (this.productionYear) {
            filter.productionYear = this.productionYear;
        }
        filter.publish = this.publish;
        return {params: filter};
    }
}
